import { Injectable } from '@angular/core';

import { ResponseWrapper, Pagination } from '@library/common/http';
import { randomArray, optional, titleCase } from '@library/common/functions';
import { MockAccount, MockUser } from '@library/modules/user/mock';
import { MockActivity } from '@library/modules/activityfeed/activity.mock';

import {
   MockBusiness,
   mockCountries,
   ShipmentFactory,
   ShipmentTypes,
   ShipmentModes,
} from '@library/common/models/mock';

import { MockInvoice, MockInvoiceHeader } from '@library/modules/invoices/invoice.mock';
import { MockShipmentSnapshot } from '@library/modules/shipments/snapshot/shipment-snapshot.mock';
import { MockTemplate } from '@library/modules/templates/template.mock';

import {
   MockReportList,
   MockReportColumn,
   MockReport,
   MockReportResponse,
} from '@library/modules/reports/report.mock';

import * as faker from 'faker';

@Injectable({
   providedIn: 'root',
})
export class MockService {
   mock( url: string, body?: any ): any {
      return JSON.parse( JSON.stringify( this.wrap( url.match( /((?:\/?[a-zA-Z_]+)+)(\/[\w-]+)?(\?.*)?$/ ), body )));
   }

   pagination( pagination?: any ): Pagination {
      return {
         hash: pagination?.hash || 'mock-hash',
         page: pagination?.page || 1,
         total: pagination?.total || Math.ceil( Math.random() * 10 )
      };
   }

   wrap( parsedURL, body? ) {
      console.log( '* mock', parsedURL );
      if ( body ) { console.log( '* mock - passed body', body ); }

      const [ , url, id, queryParams ] = parsedURL;

      if ( id ) { console.log( '* mock - found id', id ); }

      if ( queryParams ) { console.log( '* mock - queryParams', queryParams ); }

      const wrapper = {
         messages: [],
         type: 'mock',
         response: { collection: [] }
      } as ResponseWrapper<any>;

      switch ( url ) {
         case 'GETkittens':
            // fake errors
            return ({ ...wrapper, messages: [
               {
                  type: 'ALERT',
                  code: 'SOME_CRAZY_ERROR',
                  message: 'Kittens are Awesome!',
                  data: {}
               }, {
                  type: 'ALERT',
                  code: 'SOME_CRAZY_ERROR',
                  message: 'Kittens are Awesome!',
                  data: {}
               },
            ]});
         case 'GETuser':
         case 'PATCHuser/customer':
            return ({
               ...wrapper,
               messages: [
                  // { type: 'ERROR', code: 'TOU_NOT_READ', message: 'Read it', },
                  // { type: 'ERROR', code: 'TC_NOT_READ', message: 'Read it', },
                  // { type: 'ERROR', code: 'ERR', message: 'Test Error' },
                  // { type: 'ALERT', code: 'WARNING', message: 'Test Warning' },
                  // { type: 'NOTIFICATION', code: 'NOTE', message: 'Test Note' },
               ],
               response: { collection: [ new MockUser() ] }
            });
         case 'GETuser/customer':
            const customers = randomArray( MockAccount, 30 );
            if ( customers.length ) {
               customers[0].primary = true;
               customers[0].active = true;
            }

            return ({ ...wrapper, response: { collection: customers }});
         case 'GETab':
         case 'POSTab':
         case 'PATCHab':
         case 'DELETEab':
            return ({ ...wrapper, response: { collection: randomArray( MockBusiness ) }});
         case 'GETshipment':
            return ({ ...wrapper, response: { collection: [ ShipmentFactory.mock() ] }});
         case 'POSTshipment/list':
            return ({
               ...wrapper,
               response: {
                  pagination: this.pagination( body?.pagination ),
                  collection: randomArray( MockShipmentSnapshot ),
               }
            });

         case 'GETreport/manager':
            if ( id ) { return ({ ...wrapper, response: { collection: [ new MockReport() ] }}); }

            return ({ ...wrapper, response: { collection: randomArray( MockReportList ) }});
         case 'GETenum/report_columns':
            return ({ ...wrapper, response: { collection: randomArray( MockReportColumn ) }});
         case 'POSTshipment/report':
            return ({ ...wrapper, response: {
               ...new MockReportResponse( body?.schema ),
               pagination: this.pagination( body?.pagination ),
            }});

         case 'POSTshipment/book':
            return ({ ...wrapper, response: { collection: [ '123456789' ] }});
         case 'GETtemplate':
            if ( id ) { return ({ ...wrapper, response: { collection: [ new MockTemplate() ] }}); }

            return ({ ...wrapper, response: { collection: randomArray( MockTemplate ) }});

         case 'GETinvoice':
         case 'GETinvoice/list':
            if ( id || queryParams ) { return ({ ...wrapper, response: { collection: randomArray( MockInvoice, 50 ) }}); }

            return ({ ...wrapper, response: { collection: randomArray( MockInvoiceHeader ) }});

         case 'GETactivityfeed':
            return ({ ...wrapper, response: {
               collection: randomArray( MockActivity, 50 ),
               isMore: optional(),
               lastId: faker.datatype.number(),
            }});
         case 'GETactivityfeed/recover':
            return ({ ...wrapper, response: { collection: [] }});

         // enums
         case 'GETenum/servicelevels':
            return ({
               ...wrapper,
               response: {
                  collection: Array.from({ length: faker.datatype.number( 50 )}, _ => ({
                     name: titleCase( faker.lorem.words(2) ),
                     shipType: faker.random.arrayElement( ShipmentTypes ),
                     mode: faker.random.arrayElement( ShipmentModes ),
                     book: optional( 80 )
                  })),
               }
            });

         case 'GETenum/currencies':
            return ({ ...wrapper, response: { collection: [ 'USD', 'CAD' ] }});

         case 'GETenum/countries':
         case 'GETenum/ocean_ports':
            return ({ ...wrapper, response: { collection: mockCountries }});

         case 'POSTuser/preferences':
            console.log( '* mock - POSTuser/preferences', body );
      }

      if ( url.includes( 'enum' )) {
         return ({ ...wrapper, response: { collection:
            Array.from({
               length: faker.datatype.number({ min: 1, max: 10 })
            }, _ => titleCase( faker.company.bs() ) as string )
         }});
      }

      return wrapper;
   }
}
